import { Directive, Inject, Input, NgZone } from '@angular/core';
import { LeafletControlLayersWrapper, LeafletDirective, LeafletDirectiveWrapper, LeafletLayersControlDirective } from '@bluehalo/ngx-leaflet';
import * as L from 'leaflet';
import { environment } from 'src/environments/environment';

@Directive({
  selector: '[mtxTileLayer]',
  standalone: false,
})
export class TileLayerDirective {

  @Input()
  public mtxTileLayer: any;

  private readonly leafletDirectiveWrapper: LeafletDirectiveWrapper;

  private readonly layerControlWrapper: LeafletControlLayersWrapper;

  private googleRoadLayer?: L.Layer;

  private googleAerialLayer?: L.Layer;

  private readonly hereRoadLayer?: L.Layer;

  private readonly hereAerialLayer?: L.Layer;

  private osmRoadLayer?: L.Layer;

  private hereTrafficOverlay?: L.Layer;

  public constructor(@Inject(LeafletDirective) private readonly leafletDirective: LeafletDirective,
    @Inject(LeafletLayersControlDirective) private readonly leafletLayerControlDirective: LeafletLayersControlDirective,
    @Inject(NgZone) private readonly zone: NgZone) {
    this.leafletDirectiveWrapper = new LeafletDirectiveWrapper(leafletDirective);
    this.layerControlWrapper = new LeafletControlLayersWrapper(zone,
      leafletLayerControlDirective.layersControlReady);

    /*
     * todo: do a PR to change this from EventEmitter so we dont have to subscribe so early.
     * this also may not be early enough where the real issue could come in..
     */
    this.leafletLayerControlDirective.layersControlReady.subscribe(ctrl => {
      this.addAlternateLayers(ctrl);
      this.setInitialBaseLayer();
    });
  }

  private setInitialBaseLayer(): void {
    // Add the default layer
    this.zone.runOutsideAngular(() => {
      if (environment.defaultMapProvider === 'google' && this.googleRoadLayer) {
        this.leafletDirective.getMap().addLayer(this.googleRoadLayer);
      } else if (this.osmRoadLayer) {
        this.leafletDirective.getMap().addLayer(this.osmRoadLayer);
      } /* else if (environment.defaultMapProvider === 'here') {
                this.leafletDirective.getMap().addLayer(this.hereRoadLayer);
            }*/
    });
  }


  private addAlternateLayers(control: L.Control.Layers): void {
    this.googleRoadLayer = new L.TileLayer('https://{s}.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}',
      {
        maxZoom: 20,
        subdomains: [
          'mt0',
          'mt1',
          'mt2',
          'mt3',
        ],
        detectRetina: true,
      });

    this.googleAerialLayer = new L.TileLayer('https://{s}.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}',
      {
        maxZoom: 20,
        subdomains: [
          'mt0',
          'mt1',
          'mt2',
          'mt3',
        ],
        detectRetina: true,
      });

    this.osmRoadLayer = new L.TileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      {
        maxZoom: 18,
      });

    this.hereTrafficOverlay = new L.TileLayer(
      `https://traffic.maps.hereapi.com/v3/flow/mc/{z}/{x}/{y}/png?apiKey=${environment.hereMapsApiKey}&size=256`,
      {
        subdomains: [
          '1',
          '2',
          '3',
          '4',
        ],
      },
    );

    this.zone.runOutsideAngular(() => {
      control.addBaseLayer(this.googleRoadLayer!, 'Google Road');
      control.addBaseLayer(this.googleAerialLayer!, 'Google Aerial');
      control.addBaseLayer(this.osmRoadLayer!, 'OSM Road');
      control.addOverlay(this.hereTrafficOverlay!, 'Traffic');

      /*
       * control.addBaseLayer(this.hereRoadLayer, 'HERE Road');
       * control.addBaseLayer(this.hereAerialLayer, 'HERE Aerial');
       */
    });
  }

}
